import { useMemo } from 'react';

import {
  DEFAULT_SCREEN_OPTIONS,
  type ScreenOptionsMap,
} from '../../../../constants';
import { useRouteTitles } from '../../../messages';

/**
 * Screen options for the menu tab layout.
 */
export const useMenuTabStackOptions = () => {
  const titles = useRouteTitles();

  return useMemo(() => {
    return {
      //
      // ─── Main Stack Options (applied to all screens) ─────────────────────

      Stack: DEFAULT_SCREEN_OPTIONS,

      // ─── Individual Tabs ─────────────────────────────────────────────────

      Locations: { title: titles.locationsTitle },
    } satisfies ScreenOptionsMap;
  }, [titles]);
};
